import React from "react";
import checkIcon from "../../assets/icons/loadingGreen.svg";
import crossIcon from "../../assets/icons/loadingRed.svg";
import { accountNames, accountTitles } from "../../constants";
import { ReactComponent as Startups } from "../../assets/icons/startups_ic.svg";
import { ReactComponent as Businesses } from "../../assets/icons/growing_businesses_ic.svg";
import { ReactComponent as EstablishedBusinesses } from "../../assets/icons/established_businesses_ic.svg";
import { CurrencyDisplay } from "../../utils/formatCurrency";

export const INITIAL_SECTION_POSITION = 0;

export const RAK_STARTER_CONFIRM_MESSAGE =
  "Please note that RAKstarter account is only available for business with a length of business less than a year. Would you like to learn more about RAKstarter account?";

export const RAK_SAVE_CLOSE_CONFIRM_MESSAGE =
  "Are you sure you want to save the changes and exit the application?";

export const featuresDataList = [
  {
    info: "Lifestyle benefits**",
    starter: { ic: checkIcon },
    currentAccount: { ic: checkIcon },
    elite: { ic: checkIcon }
  },
  {
    info: "Account currency",
    starter: "AED",
    currentAccount: "AED",
    elite: "AED"
  },
  {
    info: "Foreign currency transactions",
    starter: { ic: checkIcon },
    currentAccount: { ic: checkIcon },
    elite: { ic: checkIcon }
  }
];

export const feesChargesDataRows = [
  {
    info: "Monthly average credit balance",
    starter: "Zero",
    currentAccount: (
      <p className="no-margin">
        <span className="aed-currency">AED 25,000</span>
        <br /> or equivalent at entity level
      </p>
    ),
    elite: (
      <p className="no-margin">
        <span className="aed-currency">AED 500,000</span>
        <br /> or equivalent at entity level
      </p>
    )
  },
  {
    info: "Fall back fee (if monthly average credit balance is not maintained)",
    starter: "Zero",
    currentAccount: CurrencyDisplay({ amount: "52.50" }),
    elite: CurrencyDisplay({ amount: "262.50" })
  },
  {
    info: "Monthly maintenance fees",
    starter: CurrencyDisplay({ amount: "103.95" }),
    currentAccount: CurrencyDisplay({ amount: "103.95" }),
    elite: "Zero"
  },
  {
    info: "Monthly digital banking fees",
    starter: "Zero",
    currentAccount: CurrencyDisplay({ amount: "52.50" }),
    elite: CurrencyDisplay({ amount: "52.50" })
  }
];
export const perksDataRows = [
  {
    info: "Zero balance account",
    starter: { ic: checkIcon },
    currentAccount: { ic: crossIcon },
    elite: { ic: crossIcon }
  },
  {
    info: "Free remittances*",
    starter: { ic: checkIcon },
    currentAccount: { ic: checkIcon },
    elite: { ic: checkIcon }
  },
  {
    info: "Preferential FX rates**",
    starter: { ic: checkIcon },
    currentAccount: { ic: checkIcon },
    elite: { ic: checkIcon }
  },
  {
    info: "Free accounting packages and\nbusiness insurance**",
    starter: { ic: checkIcon },
    currentAccount: { ic: checkIcon },
    elite: { ic: checkIcon }
  },
  {
    info: "Dedicated Relationship Manager",
    starter: { ic: checkIcon },
    currentAccount: { ic: checkIcon },
    elite: { ic: checkIcon }
  },
  {
    info: "Priority services across branches",
    starter: { ic: crossIcon },
    currentAccount: { ic: crossIcon },
    elite: { ic: checkIcon }
  }
];

export const accountTypes = {
  starter: {
    id: "starter",
    accountName: accountNames.starter,
    name: accountTitles.starter,
    position: 2
  },
  currentAccount: {
    id: "currentAccount",
    accountName: accountNames.currentAccount,
    name: accountNames.currentAccount,
    position: 3
  },
  elite: {
    id: "elite",
    accountName: accountNames.elite,
    name: accountTitles.elite,
    position: 4
  }
};

export const sizes = {
  INITIAL_OFFSET: 395,
  SELECTED_ELEM_WIDTH: "190px",
  OFFSET: 5
};

export const accountTypesDescription = {
  info: {
    name: "",
    Icon: "",
    title: "",
    description: [
      "Zero balance account",
      "Free remittances & preferential forex rates",
      "Free accounting \npackage & business insurance"
    ],
    buttonText: "",
    applyNowButton: ""
  },
  starter: {
    name: accountTitles.starter,
    accountName: accountNames.starter,
    Icon: Startups,
    title: "For start-ups and entrepreneurs",
    description: [
      "Zero balance account",
      "Free remittances & preferential forex rates",
      "Free accounting \npackage & business insurance"
    ],
    buttonText: accountTypes.starter.name,
    applyNowButton: "Apply now"
  },
  currentAccount: {
    name: accountTitles.currentAccount,
    accountName: accountNames.currentAccount,
    Icon: Businesses,
    title: "For growing businesses",
    description: [
      "Low balance account",
      "Preferential transaction fees",
      "Dedicated relationship Manager "
    ],
    buttonText: accountTypes.currentAccount.name,
    applyNowButton: "Apply now"
  },
  elite: {
    name: accountTitles.elite,
    accountName: accountNames.elite,
    Icon: EstablishedBusinesses,
    title: "For established businesses",
    description: [
      "Select free services",
      "Host of lifestyle benefits",
      "Priority servicing & Dedicated Relationship Manager"
    ],
    buttonText: accountTypes.elite.name,
    applyNowButton: "Apply now"
  }
};

export const COMPARED_ACCOUNTS_TYPES = {
  [accountTypes.starter.id]: [accountTypes.starter.id, accountTypes.currentAccount.id],
  [accountTypes.currentAccount.id]: [accountTypes.currentAccount.id, accountTypes.elite.id],
  [accountTypes.elite.id]: [accountTypes.elite.id, accountTypes.currentAccount.id]
};
